import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Group, ScrollArea, Stack, Text, rem } from "@mantine/core";
import { Dropzone, MIME_TYPES } from "@mantine/dropzone";
import { CloseOutlined, CloudUploadOutlined, FilePresentOutlined } from "@mui/icons-material";
import { doesArrayHaveData } from "../../utils/Array.utils";
import { showErrorNotification } from "../Notifications";
import { FileUploadPreviewCard } from "./FileUploadPreviewCard";
export const FileUpload = ({ isEditing = false, files = [], dropzoneStyles, setFiles, onRemove, onUpdate, fileTypeOptions = [] }) => {
    // 500 MB max file size
    const MAX_FILE_SIZE = 500 * 1024 * 1024;
    // Data
    const hasFiles = doesArrayHaveData(files);
    // Handlers
    const handleRejectedFiles = (rejections) => {
        for (const rejection of rejections) {
            for (const error of rejection.errors) {
                if (error.code === "file-too-large") {
                    const sizeMB = Math.round(rejection.file.size / (1024 * 1024));
                    showErrorNotification(`"${rejection.file.name}" is ${sizeMB} MB which exceeds the 500 MB limit.`);
                }
                else if (error.code === "file-invalid-type") {
                    showErrorNotification(`"${rejection.file.name}" is not a supported file type.`);
                }
                else {
                    showErrorNotification(error.message);
                }
            }
        }
    };
    const handleLoadFiles = (files) => {
        // If we're editing a file, don't allow the user to drop new files on
        if (isEditing)
            return;
        if (!doesArrayHaveData(files)) {
            showErrorNotification("No files selected");
            return;
        }
        setFiles(files);
    };
    return (_jsx(Dropzone, { accept: [
            MIME_TYPES.png,
            MIME_TYPES.gif,
            MIME_TYPES.jpeg,
            MIME_TYPES.svg,
            MIME_TYPES.webp,
            MIME_TYPES.heic,
            MIME_TYPES.heif,
            MIME_TYPES.mp4,
            MIME_TYPES.zip,
            MIME_TYPES.rar,
            MIME_TYPES.csv,
            MIME_TYPES.pdf,
            MIME_TYPES.doc,
            MIME_TYPES.docx,
            MIME_TYPES.xls,
            MIME_TYPES.xlsx,
            MIME_TYPES.ppt,
            MIME_TYPES.pptx
        ], style: dropzoneStyles, multiple: true, maxSize: MAX_FILE_SIZE, onDrop: handleLoadFiles, onReject: handleRejectedFiles, children: _jsxs(Stack, { flex: 1, gap: "xs", children: [_jsxs(Group, { variant: "centered", mt: "md", style: { pointerEvents: "none" }, children: [_jsx(Dropzone.Accept, { children: _jsx(CloudUploadOutlined, { style: {
                                    width: rem(32),
                                    height: rem(32),
                                    color: "var(--mantine-color-secondary-5)"
                                } }) }), _jsx(Dropzone.Reject, { children: _jsx(CloseOutlined, { style: {
                                    width: rem(32),
                                    height: rem(32),
                                    color: "var(--mantine-color-red-6)"
                                } }) }), _jsx(Dropzone.Idle, { children: _jsx(FilePresentOutlined, { style: {
                                    width: rem(32),
                                    height: rem(32),
                                    color: "var(--mantine-color-dimmed)",
                                    animation: "bounce 2s infinite"
                                } }) }), _jsxs("div", { children: [_jsx(Text, { variant: "body", size: hasFiles ? "sm" : "sm", c: "dimmed", inline: true, fw: 500, children: "Drag files here or click to select" }), _jsx(Text, { variant: "meta-muted", inline: true, mt: 4, children: "You can upload multiple files at once." })] })] }), hasFiles && (_jsx(ScrollArea, { type: "hover", scrollbarSize: 8, offsetScrollbars: true, styles: { viewport: { paddingBottom: "10px" } }, children: _jsx(Flex, { gap: "md", py: "xs", px: "xs", children: files.map((f, index) => (_jsx(FileUploadPreviewCard, { index: index, fileEntry: f, fileTypeOptions: fileTypeOptions, onRemove: onRemove || (() => { }), onUpdate: onUpdate || (() => { }) }, index))) }) }))] }) }));
};
